import { useState } from "react";

type Props = {
  pageSize?: number;
  pageNo?: number;
  total?: number;
};

type ReturnType = [
  {
    pageNo: number;
    pageSize: number;
    total: number;
  },
  {
    setPageSize: (v: number) => any;
    setPageNo: (v: number) => any;
    setTotal: (v: number) => any;
  }
];

export default function usePagination(props: Props): ReturnType {
  const [pageSize, setPageSize] = useState<number>(props.pageSize || 20);
  const [pageNo, setPageNo] = useState<number>(props.pageNo || 1);
  const [total, setTotal] = useState<number>(props.total || 0);

  return [
    { pageNo, pageSize, total },
    { setPageSize, setPageNo, setTotal },
  ];
}
